import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';
import { FormsModule } from '@angular/forms'
import { TaskInputComponent } from './taskinput/taskinput.component';
import { InputModule } from '../Input/input.module';
import { ProgressChartModule } from '../cp-progresschart/cp-progresschart.module';
import { LoadingButtonModule } from '../cp-loadingbutton/cp-loadingbutton.module';
import { TaskboardComponent } from './taskboard/taskboard.component';
import { TaskChartsModule } from './taskcharts/taskcharts.module';
import { InputChartsModule } from '../Input/inputcharts/inputcharts.module';

@NgModule({
  declarations: [
    TaskInputComponent,
    TaskboardComponent
  ],
  imports: [
    CommonModule,
    PoModule,
    FormsModule,
    InputModule,
    ProgressChartModule,
    LoadingButtonModule,
    TaskChartsModule,
    InputChartsModule
  ],
  exports: [
    TaskboardComponent
  ]
})
export class TaskModule {}
